import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section id="home" className="relative min-h-screen bg-[#F5E6D3]">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-[#2C1810] shadow-lg' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 lg:px-12 py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="cursor-pointer">
              <img 
                src="https://static.readdy.ai/image/77dfda70a227b79a5ca6ebe791df28a2/ac0c68493b0c85fe164001f996b36c2f.png" 
                alt="Ministry Logo" 
                className="h-12 w-auto"
              />
            </a>
            <div className="hidden md:flex items-center gap-8">
              <a href="#mission" className="text-sm font-['DM_Sans'] text-[#F5E6D3] hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                MISSION
              </a>
              <a href="#subsidiaries" className="text-sm font-['DM_Sans'] text-[#F5E6D3] hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                OUTREACH
              </a>
              <a href="#news" className="text-sm font-['DM_Sans'] text-[#F5E6D3] hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                STORIES
              </a>
              <a href="#calendar" className="text-sm font-['DM_Sans'] text-[#F5E6D3] hover:text-[#D4A574] transition-colors cursor-pointer tracking-wide">
                EVENTS
              </a>
              <a href="#contact" className="px-6 py-2 border-2 border-[#D4A574] text-[#F5E6D3] text-sm font-['DM_Sans'] hover:bg-[#D4A574] hover:text-[#2C1810] transition-all cursor-pointer whitespace-nowrap tracking-wide">
                CONTACT
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="relative min-h-screen flex items-center justify-center px-6 lg:px-12 pt-20">
        <div className="absolute inset-0 overflow-hidden">
          <img 
            src="https://public.readdy.ai/ai/img_res/fd95236e71349eefa0790983cce71c5c.jpg"
            alt="Spiritual Foundations"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#2C1810]/60"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#2C1810]/40 to-[#F5E6D3]"></div>
        </div>

        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <div className="mb-6 inline-block px-6 py-2 border-2 border-[#D4A574] bg-[#2C1810]/80">
            <p className="text-sm font-['Space_Mono'] text-[#D4A574] tracking-widest">
              FAITH • HOPE • LOVE
            </p>
          </div>
          
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#F5E6D3] mb-6 font-['Space_Mono'] leading-tight">
            LEGACY<br />IN CHRIST
          </h1>
          
          <p className="text-lg md:text-xl text-[#F5E6D3] mb-8 font-['DM_Sans'] max-w-2xl mx-auto leading-relaxed">
            Serving communities through ministry, compassion, and spiritual transformation
          </p>

          <div className="bg-[#2C1810]/80 border-2 border-[#D4A574] p-6 md:p-8 mb-10 max-w-3xl mx-auto">
            <p className="text-base md:text-lg text-[#F5E6D3] font-['Crimson_Text'] italic leading-relaxed">
              "Therefore if any man be in Christ, he is a new creature: old things are passed away; behold, all things are become new."
            </p>
            <p className="text-sm text-[#D4A574] font-['Space_Mono'] mt-3 tracking-wide">
              — 2 CORINTHIANS 5:17
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a 
              href="#mission"
              className="px-8 py-4 bg-[#D4A574] text-[#2C1810] font-bold font-['Space_Mono'] hover:bg-[#F5E6D3] transition-all cursor-pointer whitespace-nowrap tracking-wide text-sm"
            >
              DISCOVER OUR MISSION
            </a>
            <a 
              href="#calendar"
              className="px-8 py-4 border-2 border-[#F5E6D3] text-[#F5E6D3] font-bold font-['Space_Mono'] hover:bg-[#F5E6D3] hover:text-[#2C1810] transition-all cursor-pointer whitespace-nowrap tracking-wide text-sm"
            >
              VIEW EVENTS
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#F5E6D3] rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-2 bg-[#F5E6D3] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>
  );
}
